var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question_option--container"},[_c('button',{class:{ 'is-active': _vm.editor.isActive('answer') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleAnswer()
        .run()}}},[_vm._v(" answer ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('math') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleMath()
        .run()}}},[_vm._v(" math ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('bold') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleBold()
        .run()}}},[_vm._v(" bold ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('italic') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleItalic()
        .run()}}},[_vm._v(" italic ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('strike') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleStrike()
        .run()}}},[_vm._v(" strike ")]),_c('button',{on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .unsetAllMarks()
        .run()}}},[_vm._v(" clear marks ")]),_c('button',{on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .clearNodes()
        .run()}}},[_vm._v(" clear nodes ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('paragraph') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .setParagraph()
        .run()}}},[_vm._v(" paragraph ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('bulletList') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleBulletList()
        .run()}}},[_vm._v(" bullet list ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('orderedList') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleOrderedList()
        .run()}}},[_vm._v(" ordered list ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('romanList') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleRomanList()
        .run()}}},[_vm._v(" roman list ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('alphabetList') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleAlphabetList()
        .run()}}},[_vm._v(" alphabet list ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('answerSection') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleAnswerSection('empty')
        .run()}}},[_vm._v(" answer section ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('answerSection') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleAnswerSection('line')
        .run()}}},[_vm._v(" answer section (line) ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('langEnglish') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleLangEnglish()
        .run()}}},[_vm._v(" English ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive('langMalay') },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .toggleLangMalay()
        .run()}}},[_vm._v(" Malay ")]),_c('button',{on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .setHorizontalRule()
        .run()}}},[_vm._v(" horizontal rule ")]),_c('button',{on:{"click":_vm.addImage}},[_vm._v(" add image from URL ")]),_c('button',{on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .undo()
        .run()}}},[_vm._v(" undo ")]),_c('button',{on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .redo()
        .run()}}},[_vm._v(" redo ")]),_c('ActionTable',{attrs:{"editor":_vm.editor}}),_c('ActionTextAlign',{attrs:{"editor":_vm.editor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }